import React, { useTransition } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import Home from './pages/Home'
import NewLead from './pages/NewLead'
import NotFound from './pages/NotFound'
import Politique from './pages/Politique'
// import Benefits from './pages/Benefits'
// import { default as BadCreditLoanRoot } from './pages/BadCreditLoan'
import BadCreditLoan from './pages/situations/BadCreditLoan'
import { HelmetProvider } from 'react-helmet-async'

import i18n from 'i18next'
import MicroLoan100 from './pages/micro-loan/MicroLoan100'
import MicroLoan200 from './pages/micro-loan/MicroLoan200'
import MicroLoan300 from './pages/micro-loan/MicroLoan300'
import LoanNoJob from './pages/situations/LoanNoJob'
import NoRefusalPaydayLoans from './pages/needs/NoRefusalPaydayLoans'
import EmergencyLoan from './pages/needs/EmergencyLoan'
// import { default as PersonnalizedLoanRoot } from './pages/Benefits'
import PersonnalizedLoan from './pages/benefits/PersonnalizedLoan'
import InstantLoan from './pages/benefits/InstantLoan'
import NoCreditCheckLoan from './pages/benefits/NoCreditCheckLoan'
import NoRefusalLoan from './pages/benefits/NoRefusalLoan'
import InstantEtransferLoan from './pages/benefits/InstantEtransferLoan'
import ScrollToTop from './utils/ScrollToTop'

function App() {
    const helmetContext = {}
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang)
    }

    return (
        <HelmetProvider context={helmetContext}>
            <Router>
                <ScrollToTop />
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={() => {
                            changeLanguage('fr')
                            return <Home />
                        }}
                    />
                    <Route
                        path="/fr"
                        render={() => {
                            window.location.href = 'https://argentaujourdhui.com'
                            return null
                        }}
                    />
                    <Route
                        path="/en"
                        render={() => {
                            window.location.href = 'https://goodgoodfinance.com'
                            return null
                        }}
                    />

                    <Route exact path="/new-lead" component={NewLead} />

                    {/* Avantages */}
                    {/* <Route exact path="/avantages" component={PersonnalizedLoanRoot} /> */}
                    <Route
                        exact
                        path="/avantages/pret-personnalise"
                        component={PersonnalizedLoan}
                    />
                    <Route exact path="/avantages/pret-rapide" component={InstantLoan} />
                    <Route
                        exact
                        path="/avantages/pret-sans-enquete-credit"
                        component={NoCreditCheckLoan}
                    />
                    <Route exact path="/avantages/pret-sans-refus" component={NoRefusalLoan} />
                    <Route
                        exact
                        path="/avantages/pret-virement-immediat"
                        component={InstantEtransferLoan}
                    />

                    {/* Besoins */}
                    <Route
                        exact
                        path="/besoins/pret-sur-salaire-aucun-refus"
                        component={NoRefusalPaydayLoans}
                    />
                    <Route exact path="/besoins/pret-urgent-rapide" component={EmergencyLoan} />

                    {/* Micro prêts */}
                    <Route exact path="/micro-prets/100" component={MicroLoan100} />
                    <Route exact path="/micro-prets/200" component={MicroLoan200} />
                    <Route exact path="/micro-prets/300" component={MicroLoan300} />

                    {/* Situations */}
                    {/* <Route exact path="/situations" component={BadCreditLoanRoot} /> */}
                    <Route exact path="/situations/pret-mauvais-credit" component={BadCreditLoan} />
                    <Route exact path="/situations/pret-sans-emploi" component={LoanNoJob} />

                    <Route exact path="/politique_confidentialite" component={Politique} />
                    <Route path="*" component={NotFound} />
                </Switch>
            </Router>
        </HelmetProvider>
    )
}

export default App
